import React from 'react';
import { Grid } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';

import { METADATA } from '../../../constants';
import ButtonAppBar from '../ButtonAppBar';


const useStyles = makeStyles((theme) => createStyles({
  root: {
    justifyContent: 'center',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    backgroundColor: '#E27D60',
    height: '100%'
  },
  loginInnerContainer: {
    opacity: '0.9',
    padding: '40px'
  },
  credentialsInputField: {
    marginBottom: '1rem',
    marginTop: '0px',

    '& input': {
      height: '24px',
      padding: '0.5rem 0.75rem',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      color: '#495057',
      backgroundColor: '#FFF',
      border: '1px solid rgba(0,0,0,.15)'
    }
  },
  headerTitle: {
    marginBottom: '1.5rem',
    fontWeight: '600',
    fontFamily: 'Epidemic, sans-serif',
    lineSpacing: '-0.02em',
    fontSize: '3rem',
    lineHeight: '3.5rem',
    color: '#FFF'
  }
}));


export default function CommercialSubscriptionLogin() {
  const classes = useStyles();

  return (
    <Grid container className={classes.root} justify="center">
      <Helmet>
        <meta name="description" content={METADATA.COMMERCIALSUBSCRIPTIONDASHBOARD.description} />
        <title>{METADATA.COMMERCIALSUBSCRIPTIONDASHBOARD.title}</title>
      </Helmet>
      <ButtonAppBar />
      {/* <Grid
        item
        className="login-box"
        justify="center"
        xs={11}
        md={8}
        lg={5}
      >
        <Box container xs={12}>
          <div className={classes.loginInnerContainer}>
            <h1 className={classes.headerTitle}>Login Account</h1>
            <form>
              <TextField
                className={classes.credentialsInputField}
                type="text"
                id="username"
                name="username"
                placeholder="Username"
                fullWidth
                margin="normal"
                autoFocus
                // value={username}
                // onChange={handleChange}
              />

              <TextField
                className={classes.credentialsInputField}
                type="password"
                id="password"
                name="password"
                placeholder="Password"
                fullWidth
                margin="normal"
                // value={password}
                // onChange={handleChange}
              />
              <Button
                variant="contained"
                type="submit"
              >
                LOGIN
              </Button>
            </form>
          </div>
        </Box>
      </Grid> */}
    </Grid >
  )
}
